/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_A1dInputs */

const en_mk_sol_ukm_a1d = /** @type {(inputs: Mk_Sol_Ukm_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recaps daily sales per branch, flags what needs attention, chases invoices.`)
};

const id_mk_sol_ukm_a1d = /** @type {(inputs: Mk_Sol_Ukm_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merekap penjualan harian per cabang, menandai yang perlu perhatian, mengingatkan invoice.`)
};

/**
* | output |
* | --- |
* | "Recaps daily sales per branch, flags what needs attention, chases invoices." |
*
* @param {Mk_Sol_Ukm_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_a1d = /** @type {((inputs?: Mk_Sol_Ukm_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_a1d(inputs)
	return en_mk_sol_ukm_a1d(inputs)
});